module.exports = __webpack_public_path__ + "img/dialog-share-map.1312d2f5.jpg";